/**
 * Browser utilities for safe access to localStorage and window properties
 */

/**
 * Safely get ad configuration from localStorage or window.config
 * @returns {Object} Ad configuration object
 */
export const getAdConfig = () => {
  try {
    if (typeof window !== 'undefined') {
      return localStorage.ads || window.config || {};
    }
    return {};
  } catch (error) {
    return {};
  }
};

/**
 * Safely get a value from localStorage
 * @param {string} key - The localStorage key
 * @param {*} defaultValue - Default value if key doesn't exist
 * @returns {string} The stored value or default
 */
export const getLocalStorage = (key, defaultValue = null) => {
  try {
    if (typeof window !== 'undefined' && localStorage[key]) {
      return localStorage[key];
    }
    return defaultValue;
  } catch (error) {
    return defaultValue;
  }
};

/**
 * Safely set a value in localStorage
 * @param {string} key - The localStorage key
 * @param {*} value - The value to store
 */
export const setLocalStorage = (key, value) => {
  try {
    if (typeof window !== 'undefined') {
      localStorage[key] = value;
    }
  } catch (error) {
    // Silently fail if localStorage is not available
  }
};

/**
 * Safely get a boolean value from localStorage
 * @param {string} key - The localStorage key
 * @param {boolean} defaultValue - Default boolean value
 * @returns {boolean} The stored boolean value or default
 */
export const getLocalStorageBoolean = (key, defaultValue = false) => {
  const value = getLocalStorage(key, String(defaultValue));
  return value === 'true';
};

/**
 * Safely set a boolean value in localStorage
 * @param {string} key - The localStorage key
 * @param {boolean} value - The boolean value to store
 */
export const setLocalStorageBoolean = (key, value) => {
  setLocalStorage(key, String(value));
};

